"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const BasicNode_1 = require("./BasicNode");
const types_1 = require("../types");
const validations_1 = require("../validations");
const fetchOutputKeys_1 = require("../helper/fetchOutputKeys");
const typeUtils_1 = require("../types/typeUtils");
const utils_1 = require("../helper/utils");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
class ActionNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.ACTION };
    if (props.type !== types_1.NODE_TYPES.ACTION)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = {
      service: "",
      method: "",
      params: null,
      waitForAction: ""
    };
    if (!nodeData) return deserializeData;
    let paramsValue = JSON.parse(
      JSON.stringify(nodeData.params || {}, null, 2).replace(
        ' ":',
        '"$wf.variables.'
      )
    );
    deserializeData = {
      service: nodeData.service,
      method: nodeData.method,
      params: { paramsValue, error: false },
      waitForAction: nodeData.waitForAction
    };
    return deserializeData;
  }
  serialize(uiData) {
    let params = uiData.params ? uiData.params.paramsValue : {};
    params = JSON.parse(
      JSON.stringify(params, null, 2).replace(/\$wf.variables./g, ":")
    );
    let data = {
      service: uiData.service,
      method: uiData.method,
      params,
      waitForAction: uiData.waitForAction
    };
    return data;
  }
  getAttachedApis(selectedResource) {
    let data = this.getNodeData();
    if (!data) return [];
    let { service, method } = data;
    return [{ service, method, type: typeUtils_1.AwsApiType.Primary }];
  }
  getResourcesForSelectedMethod() {
    let resources = [];
    let data = this.getNodeData();
    if (!data) return [];
    let { method } = data;
    let prettyName = utils_1.getPrettyName(method);
    resources.push({
      nodeRef: this,
      label: [this.getNodeName(), prettyName].join(".").replace(" ", ""),
      selectedResourceId: this.id,
      path: "",
      context: {
        outputPath: ""
      }
    });
    return resources;
  }
  async getAvailableResources() {
    let resources = [];
    resources = resources.concat(this.getResourcesForSelectedMethod());
    return resources;
  }
  async getOutputKeys(params) {
    let nodeData = this.getNodeData();
    if (!nodeData || !nodeData.service || !nodeData.method) return [];
    let { service, method } = nodeData;
    let outputKeys = await fetchOutputKeys_1.fetchOutputKeys(
      this.getDataResolver(),
      service,
      method
    );
    if (
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.outputPath
    )
      return outputKeys;
    return this.getKeysForPath(params.resource.context.outputPath, outputKeys);
  }
  validate() {
    return new validations_1.ActionNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.AWS;
  }
}
exports.ActionNode = ActionNode;
//# sourceMappingURL=ActionNode.js.map
